import { NavigateFunction } from "react-router-dom";

export interface IOptionsQueryParams {
    page: "task" | "board" | "project";
    entity: "chat" | "chat-chek-list" | "sub-task-form" | "task-form" | "column-task-form" | undefined;
    action: "edit" | "create" | undefined;
    entityId: number | undefined;
    cheklistId?: number;
}

export interface IQuery {
    arguments?: IArgument[],
    fragment?: IFragment[]
}

export interface IArgument {
    argument: string,
    value: string
}

export interface IFragment {
    fragment: string,
    value: string
}

export function createArgumentIfDefined(key: string, value: any): IArgument | null {
    return value !== undefined && value !== null && value !== '' ? {
        argument: key,
        value: String(value)
    } : null;
}

/**
 * 
 * @param url текущий идентификатор ресурса
 * @param params параметры для заполнения
 * @param clearOldParams заполнить с очисткой старых параметров (да/нет)
 */
export function urlFiller(
    url: string,
    params: IQuery,
    clearOldParams: boolean,
    navigate: NavigateFunction,
    isNavigator?: boolean,
    isTaskNavigation?: boolean
): void {
    try {
        const urlObj = new URL(url);

        if (clearOldParams) {
            urlObj.search = '';
        }

        if (!params.arguments) {
            return;
        }

        const searchParams = urlObj.searchParams;
        params.arguments.forEach(arg => {
            searchParams.set(arg.argument, arg.value);
        });

        if (params.fragment && params.fragment.length > 0) {
            const fragmentParams = new URLSearchParams();

            if (!clearOldParams && urlObj.hash.includes('=')) {
                const existingFragment = urlObj.hash.substring(1);
                new URLSearchParams(existingFragment).forEach((value, key) => {
                    fragmentParams.set(key, value);
                });
            }

            params.fragment.forEach(f => {
                fragmentParams.set(f.fragment, f.value);
            });

            urlObj.hash = fragmentParams.toString();
        } else if (clearOldParams) {
            urlObj.hash = '';
        }

        navigate(
            urlObj.href.replace(urlObj.origin, ""),
            { replace: true, state: { isNavigation: isNavigator === undefined ? true : isNavigator, isTaskNavigation: isTaskNavigation === undefined ? false : isTaskNavigation } }
        );
    } catch (e) {
        console.error('Invalid URL:', e);
    }
}

export function urlClear(
    url: string,
    paramsDel: string[],
    navigate: NavigateFunction,
    isNavigator?: boolean,
    isTaskNavigation?: boolean
): void {
    try {
        const urlObj = new URL(url);
        const searchParams = urlObj.searchParams;

        paramsDel.forEach(param => {
            if (searchParams.has(param)) {
                searchParams.delete(param);
            }
        });

        if (urlObj.hash.includes('=')) {
            const hashParams = new URLSearchParams(urlObj.hash.substring(1));
            let hasHashParams = false;

            paramsDel.forEach(param => {
                if (hashParams.has(param)) {
                    hashParams.delete(param);
                    hasHashParams = true;
                }
            });

            if (hasHashParams) {
                const newHash = hashParams.toString();
                urlObj.hash = newHash ? '#' + newHash : '';
            }
        }

        urlObj.search = searchParams.toString();

        if (window.location.href !== urlObj.href) {
            navigate(
                urlObj.href.replace(urlObj.origin, ""),
                { replace: true, state: { isNavigation: isNavigator === undefined ? true : isNavigator, isTaskNavigation: isTaskNavigation === undefined ? false : isTaskNavigation } }
            );
        }
    } catch (e) {
        console.error('Invalid URL:', e);
    }
}



export function getOptionsQueryParams(search: string): IOptionsQueryParams {
    const [path, query] = search.split('?');
    const queryParams = query || '';
    const clearQuery = queryParams
        .split('&')
        .filter(x => !x.includes('%'))
        .join('&');

    const params = new URLSearchParams(clearQuery);

    const result: IOptionsQueryParams = {
        page: params.get('page') as "task" | "board" | "project" || "task",
        entity: params.get('entity') as "chat" | "chat-chek-list" | "sub-task-form" | "task-form" | "column-task-form" || undefined,
        action: params.get('action') as "edit" | "create" || undefined,
        entityId: params.has('entityId') ? Number(params.get('entityId')) : undefined,
        cheklistId: params.has('cheklistId') ? Number(params.get('cheklistId')) : undefined
    };

    return result;
}